import Api from '../Api';

export default class PortalInfo extends Api {
  async getPortalInfo() {
    const response = await this.get('/portalInfo/lockdowns');
    return response;
  }
}
